// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/fonts/Thicker-Regular.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
@font-face {
  font-family: lightThicker;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.findyourrace_wrapper {
  width: 100%;
  position: relative;
}

.findyourrace_main_div {
  width: 100%;
  background-color: #fff !important;
}

.dividerband{
  display: flex;
  align-items: center;
  justify-content: center;  background-color: #000;
  color: #FFF;
  height: 150px;
  font-size: 48px;
}
.findyourracebanner img{
  width: 100%;
}
/* banner styling start here----------------------------------------------- */

.findyourrace_banner_div {
  width: 100%;
  flex-shrink: 0;
}

.findyourrace_banner_div > img {
  width: 100%;
  height: 100%;
  object-fit: fill;
}

/* cars styling start here ------------------------------------------------- */

.findyourrace_cards_div {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.findyourrace_cards_header_div {
  width: 100%;
  background: #ba1e24;
  display: flex;
  align-items: center;
  justify-content: center;
}

.findyourrace_cards_header_inner_div {
  width: 1443px !important;
  height: 310px;
  padding: 0 80px;
}

.findyourrace_cards_header {
  width: 100%;
  color: #fff;
  font-family: Thicker;
  font-size: 80px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  text-transform: capitalize;
  padding: 40px 0 0 0;
}

.findyourrace_cards_main_div {
  width: 100%;
  background-color: #262626;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 72px;
}

.findyourrace_cards_inner_div {
  width: 1443px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 19px;
  margin-top: -120px;
  padding: 0 80px;
}











@media screen and (max-width: 1200px) {
  
  /* banner styling start here----------------------------------------------- */
  
  .findyourrace_banner_div {
    width: 100%;
  }
  
  /* cars styling start here ------------------------------------------------- */

  .findyourrace_cards_header_div {
    width: 100%;
  }
  
  .findyourrace_cards_header_inner_div {
    width: 100% !important;
    height: 310px;
    padding: 0 50px;
  }
  
  .findyourrace_cards_header {
    font-size: 70px;
    padding: 60px 0 0 0;
  }
  
  .findyourrace_cards_main_div {
    width: 100%;
    padding-bottom: 72px;
  }
  
  .findyourrace_cards_inner_div {
    width: 100%;
    gap: 19px;
    margin-top: -130px;
    padding: 0 50px;
  }

}













@media screen and (max-width: 1024px) {
    
  /* banner styling start here----------------------------------------------- */
  
  .findyourrace_banner_div {
    width: 100%;
  }
  
  /* cars styling start here ------------------------------------------------- */

  .findyourrace_cards_header_div {
    width: 100%;
  }
  
  .findyourrace_cards_header_inner_div {
    width: 100% !important;
    height: 310px;
    padding: 0 40px;
  }
  
  .findyourrace_cards_header {
    font-size: 60px;
    padding: 60px 0 0 0;
  }
  
  .findyourrace_cards_main_div {
    width: 100%;
    padding-bottom: 72px;
  }
  
  .findyourrace_cards_inner_div {
    width: 100%;
    gap: 19px;
    margin-top: -140px;
    padding: 0 40px;
  }
  
}












@media screen and (max-width: 800px) {
  
  /* banner styling start here----------------------------------------------- */
  
  .findyourrace_banner_div {
    width: 100%;
  }
  
  /* cars styling start here ------------------------------------------------- */

  .findyourrace_cards_header_div {
    width: 100%;
  }
  
  .findyourrace_cards_header_inner_div {
    width: 100% !important;
    height: 310px;
    padding: 0 30px;
  }
  
  .findyourrace_cards_header {
    font-size: 54px;
    padding: 60px 0 0 0;
  }
  
  .findyourrace_cards_main_div {
    width: 100%;
    padding-bottom: 72px;
  }
  
  .findyourrace_cards_inner_div {
    width: 100%;
    gap: 12px;
    margin-top: -140px;
    padding: 0 30px;
  }
  
}















@media screen and (max-width: 700px) {
  
  /* banner styling start here----------------------------------------------- */
  
  .findyourrace_banner_div {
    width: 100%;
  }
  
  /* cars styling start here ------------------------------------------------- */

  .findyourrace_cards_header_div {
    width: 100%;
  }
  
  .findyourrace_cards_header_inner_div {
    width: 100% !important;
    height: 310px;
    padding: 0 30px;
  }
  
  .findyourrace_cards_header {
    font-size: 54px;
    padding: 60px 0 0 0;
  }
  
  .findyourrace_cards_main_div {
    width: 100%;
    padding-bottom: 72px;
  }
  
  .findyourrace_cards_inner_div {
    width: 100%;
    gap: 16px;
    margin-top: -140px;
    padding: 0 30px;
  }
  
}














@media screen and (max-width: 600px) {
  
  /* banner styling start here----------------------------------------------- */
  
  .findyourrace_banner_div {
    width: 100%;
  }
  
  /* cars styling start here ------------------------------------------------- */

  .findyourrace_cards_header_div {
    width: 100%;
  }
  
  .findyourrace_cards_header_inner_div {
    width: 100% !important;
    height: 310px;
    padding: 0 20px;
  }
  
  .findyourrace_cards_header {
    font-size: 40px;
    padding: 60px 0 0 0;
  }
  
  .findyourrace_cards_main_div {
    width: 100%;
    padding-bottom: 60px;
  }
  
  .findyourrace_cards_inner_div {
    width: 100%;
    gap: 8px;
    margin-top: -170px;
    padding: 0 20px;
  }
  
}












@media screen and (max-width: 450px) {
  
  /* banner styling start here----------------------------------------------- */
  
  .findyourrace_banner_div {
    width: 100%;
  }
  
  /* cars styling start here ------------------------------------------------- */

  .findyourrace_cards_header_div {
    width: 100%;
  }
  
  .findyourrace_cards_header_inner_div {
    width: 100% !important;
    height: 310px;
    padding: 0 16px;
  }
  
  .findyourrace_cards_header {
    font-size: 32px;
    padding: 40px 0 0 0;
  }
  
  .findyourrace_cards_main_div {
    width: 100%;
    padding-bottom: 20px;
  }
  
  .findyourrace_cards_inner_div {
    width: 100%;
    gap: 12px;
    margin-top: -210px;
    padding: 0 16px;
  }
  
}`, "",{"version":3,"sources":["webpack://./src/components/findYourRace/findYourRace.css"],"names":[],"mappings":";AACA;EACE,yBAAyB;EACzB,4CAAgD;AAClD;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB,GAAG,sBAAsB;EAChD,WAAW;EACX,aAAa;EACb,eAAe;AACjB;AACA;EACE,WAAW;AACb;AACA,6EAA6E;;AAE7E;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA,8EAA8E;;AAE9E;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;EACxB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,kBAAkB;EAClB,eAAe;AACjB;;;;;;;;;;;;AAYA;;EAEE,6EAA6E;;EAE7E;IACE,WAAW;EACb;;EAEA,8EAA8E;;EAE9E;IACE,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,SAAS;IACT,kBAAkB;IAClB,eAAe;EACjB;;AAEF;;;;;;;;;;;;;;AAcA;;EAEE,6EAA6E;;EAE7E;IACE,WAAW;EACb;;EAEA,8EAA8E;;EAE9E;IACE,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,SAAS;IACT,kBAAkB;IAClB,eAAe;EACjB;;AAEF;;;;;;;;;;;;;AAaA;;EAEE,6EAA6E;;EAE7E;IACE,WAAW;EACb;;EAEA,8EAA8E;;EAE9E;IACE,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,SAAS;IACT,kBAAkB;IAClB,eAAe;EACjB;;AAEF;;;;;;;;;;;;;;;;AAgBA;;EAEE,6EAA6E;;EAE7E;IACE,WAAW;EACb;;EAEA,8EAA8E;;EAE9E;IACE,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,SAAS;IACT,kBAAkB;IAClB,eAAe;EACjB;;AAEF;;;;;;;;;;;;;;;AAeA;;EAEE,6EAA6E;;EAE7E;IACE,WAAW;EACb;;EAEA,8EAA8E;;EAE9E;IACE,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,QAAQ;IACR,kBAAkB;IAClB,eAAe;EACjB;;AAEF;;;;;;;;;;;;;AAaA;;EAEE,6EAA6E;;EAE7E;IACE,WAAW;EACb;;EAEA,8EAA8E;;EAE9E;IACE,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,SAAS;IACT,kBAAkB;IAClB,eAAe;EACjB;;AAEF","sourcesContent":["\n@font-face {\n  font-family: lightThicker;\n  src: url(../../assets/fonts/Thicker-Regular.otf);\n}\n\n.findyourrace_wrapper {\n  width: 100%;\n  position: relative;\n}\n\n.findyourrace_main_div {\n  width: 100%;\n  background-color: #fff !important;\n}\n\n.dividerband{\n  display: flex;\n  align-items: center;\n  justify-content: center;  background-color: #000;\n  color: #FFF;\n  height: 150px;\n  font-size: 48px;\n}\n.findyourracebanner img{\n  width: 100%;\n}\n/* banner styling start here----------------------------------------------- */\n\n.findyourrace_banner_div {\n  width: 100%;\n  flex-shrink: 0;\n}\n\n.findyourrace_banner_div > img {\n  width: 100%;\n  height: 100%;\n  object-fit: fill;\n}\n\n/* cars styling start here ------------------------------------------------- */\n\n.findyourrace_cards_div {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n}\n\n.findyourrace_cards_header_div {\n  width: 100%;\n  background: #ba1e24;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.findyourrace_cards_header_inner_div {\n  width: 1443px !important;\n  height: 310px;\n  padding: 0 80px;\n}\n\n.findyourrace_cards_header {\n  width: 100%;\n  color: #fff;\n  font-family: Thicker;\n  font-size: 80px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  text-transform: capitalize;\n  padding: 40px 0 0 0;\n}\n\n.findyourrace_cards_main_div {\n  width: 100%;\n  background-color: #262626;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding-bottom: 72px;\n}\n\n.findyourrace_cards_inner_div {\n  width: 1443px;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  flex-direction: row;\n  flex-wrap: wrap;\n  gap: 19px;\n  margin-top: -120px;\n  padding: 0 80px;\n}\n\n\n\n\n\n\n\n\n\n\n\n@media screen and (max-width: 1200px) {\n  \n  /* banner styling start here----------------------------------------------- */\n  \n  .findyourrace_banner_div {\n    width: 100%;\n  }\n  \n  /* cars styling start here ------------------------------------------------- */\n\n  .findyourrace_cards_header_div {\n    width: 100%;\n  }\n  \n  .findyourrace_cards_header_inner_div {\n    width: 100% !important;\n    height: 310px;\n    padding: 0 50px;\n  }\n  \n  .findyourrace_cards_header {\n    font-size: 70px;\n    padding: 60px 0 0 0;\n  }\n  \n  .findyourrace_cards_main_div {\n    width: 100%;\n    padding-bottom: 72px;\n  }\n  \n  .findyourrace_cards_inner_div {\n    width: 100%;\n    gap: 19px;\n    margin-top: -130px;\n    padding: 0 50px;\n  }\n\n}\n\n\n\n\n\n\n\n\n\n\n\n\n\n@media screen and (max-width: 1024px) {\n    \n  /* banner styling start here----------------------------------------------- */\n  \n  .findyourrace_banner_div {\n    width: 100%;\n  }\n  \n  /* cars styling start here ------------------------------------------------- */\n\n  .findyourrace_cards_header_div {\n    width: 100%;\n  }\n  \n  .findyourrace_cards_header_inner_div {\n    width: 100% !important;\n    height: 310px;\n    padding: 0 40px;\n  }\n  \n  .findyourrace_cards_header {\n    font-size: 60px;\n    padding: 60px 0 0 0;\n  }\n  \n  .findyourrace_cards_main_div {\n    width: 100%;\n    padding-bottom: 72px;\n  }\n  \n  .findyourrace_cards_inner_div {\n    width: 100%;\n    gap: 19px;\n    margin-top: -140px;\n    padding: 0 40px;\n  }\n  \n}\n\n\n\n\n\n\n\n\n\n\n\n\n@media screen and (max-width: 800px) {\n  \n  /* banner styling start here----------------------------------------------- */\n  \n  .findyourrace_banner_div {\n    width: 100%;\n  }\n  \n  /* cars styling start here ------------------------------------------------- */\n\n  .findyourrace_cards_header_div {\n    width: 100%;\n  }\n  \n  .findyourrace_cards_header_inner_div {\n    width: 100% !important;\n    height: 310px;\n    padding: 0 30px;\n  }\n  \n  .findyourrace_cards_header {\n    font-size: 54px;\n    padding: 60px 0 0 0;\n  }\n  \n  .findyourrace_cards_main_div {\n    width: 100%;\n    padding-bottom: 72px;\n  }\n  \n  .findyourrace_cards_inner_div {\n    width: 100%;\n    gap: 12px;\n    margin-top: -140px;\n    padding: 0 30px;\n  }\n  \n}\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n@media screen and (max-width: 700px) {\n  \n  /* banner styling start here----------------------------------------------- */\n  \n  .findyourrace_banner_div {\n    width: 100%;\n  }\n  \n  /* cars styling start here ------------------------------------------------- */\n\n  .findyourrace_cards_header_div {\n    width: 100%;\n  }\n  \n  .findyourrace_cards_header_inner_div {\n    width: 100% !important;\n    height: 310px;\n    padding: 0 30px;\n  }\n  \n  .findyourrace_cards_header {\n    font-size: 54px;\n    padding: 60px 0 0 0;\n  }\n  \n  .findyourrace_cards_main_div {\n    width: 100%;\n    padding-bottom: 72px;\n  }\n  \n  .findyourrace_cards_inner_div {\n    width: 100%;\n    gap: 16px;\n    margin-top: -140px;\n    padding: 0 30px;\n  }\n  \n}\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n@media screen and (max-width: 600px) {\n  \n  /* banner styling start here----------------------------------------------- */\n  \n  .findyourrace_banner_div {\n    width: 100%;\n  }\n  \n  /* cars styling start here ------------------------------------------------- */\n\n  .findyourrace_cards_header_div {\n    width: 100%;\n  }\n  \n  .findyourrace_cards_header_inner_div {\n    width: 100% !important;\n    height: 310px;\n    padding: 0 20px;\n  }\n  \n  .findyourrace_cards_header {\n    font-size: 40px;\n    padding: 60px 0 0 0;\n  }\n  \n  .findyourrace_cards_main_div {\n    width: 100%;\n    padding-bottom: 60px;\n  }\n  \n  .findyourrace_cards_inner_div {\n    width: 100%;\n    gap: 8px;\n    margin-top: -170px;\n    padding: 0 20px;\n  }\n  \n}\n\n\n\n\n\n\n\n\n\n\n\n\n@media screen and (max-width: 450px) {\n  \n  /* banner styling start here----------------------------------------------- */\n  \n  .findyourrace_banner_div {\n    width: 100%;\n  }\n  \n  /* cars styling start here ------------------------------------------------- */\n\n  .findyourrace_cards_header_div {\n    width: 100%;\n  }\n  \n  .findyourrace_cards_header_inner_div {\n    width: 100% !important;\n    height: 310px;\n    padding: 0 16px;\n  }\n  \n  .findyourrace_cards_header {\n    font-size: 32px;\n    padding: 40px 0 0 0;\n  }\n  \n  .findyourrace_cards_main_div {\n    width: 100%;\n    padding-bottom: 20px;\n  }\n  \n  .findyourrace_cards_inner_div {\n    width: 100%;\n    gap: 12px;\n    margin-top: -210px;\n    padding: 0 16px;\n  }\n  \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
